<template>
  <aside :show.sync="show" placement="right" header="修改/添加管理员" :width="400">
    <form>
      <div class="form-group">
        <label class="control-label">姓名</label>
        <input type="text" class="form-control" v-model="admin.name">
      </div>
      <div class="form-group">
        <label class="control-label">邮箱</label>
        <input type="email" class="form-control"  v-model="admin.email" >
      </div>
      <div class="form-group">
        <label class="control-label">手机</label>
        <input type="text" class="form-control" v-model="admin.mobile">
      </div>
       <div class="form-group">
        <label class="control-label">角色</label>
        <select class="form-control" v-model="admin.role">
          <option v-for="(key, val) in adminRoles" track-by="$index" :value="key">{{val}}</option>
        </select>
      </div>
      <div class="from-group text-center">
        <button class="btn btn-primary" type="button" @click="click(submit)($event)">提交</button>
      </div>
    </form>
  </aside>
</template>

<script>
  import { aside } from 'vue-strap'
  import config from '../../libs/config'
  import utils from '../../libs/utils'
  import { pick } from 'lodash'

  export default {
    components: {
      aside
    },
    props: {
      admin: {
        required: true,
        type: Object
      },
      show: {
        required: true,
        twoWay: true
      }
    },
    data () {
      return {
        adminRoles: config.adminRoles
      }
    },
    methods: {
      submit () {
        let data = pick(this.admin, [
          'name',
          'email',
          'role',
          'mobile'
        ])
        if (this.admin.id) {
          return this.$http.put(`${config.api}/adminer/account/${this.admin.id}`, data)
            .then(() => {
              this.show = false
              this.$dispatch('callback')
            })
        } else {
          return this.$http.post(`${config.api}/adminer/account`, data)
            .then(() => {
              this.show = false
              this.$dispatch('callback')
            })
        }
      },
      click: utils.click
    }
  }
</script>

<style>

</style>



/** WEBPACK FOOTER **
 ** Edit.vue?934def5e
 **/